/**
 * Custom hook to manage address form state
 * Converts individual state variables to AddressFormState
 */

import { useMemo } from 'react'
import type { AddressFormState } from '../types/address'
import { ADDRESS_CONSTANTS } from '@/constants/address'
import type { UseAddressFormStateProps } from '../types/hooks'

/**
 * Convert individual state variables to AddressFormState
 */
export function useAddressFormState(props: UseAddressFormStateProps): AddressFormState {
  return useMemo(() => ({
    address: props.address,
    streetNumber: props.streetNumber,
    streetName: props.streetName,
    streetType: props.streetType,
    aptUnit: props.aptUnit,
    city: props.city,
    state: props.state,
    zipCode: props.zipCode,
    country: props.country || ADDRESS_CONSTANTS.DEFAULT_COUNTRY,
    outsideUS: props.outsideUS,
    residenceType: props.residenceType,
    stillHereRent: props.stillHereRent,
    moveInDateRent: props.moveInDateRent,
    leaseEndDate: props.leaseEndDate,
    landlordName: props.landlordName,
    landlordEmail: props.landlordEmail,
    landlordMobile: props.landlordMobile,
    rentAmount: props.rentAmount,
    monthsPaidRent: props.monthsPaidRent,
    stillHereOwn: props.stillHereOwn,
    moveInDateOwn: props.moveInDateOwn,
    plannedMoveOutDate: props.plannedMoveOutDate,
    monthlyMortgagePayment: props.monthlyMortgagePayment,
    monthsResided: props.monthsResided,
    stillHereFamily: props.stillHereFamily,
    moveInDateFamily: props.moveInDateFamily,
    plannedMoveOutDateFamily: props.plannedMoveOutDateFamily,
    contactName: props.contactName,
    contactEmail: props.contactEmail,
    contactMobile: props.contactMobile,
    contactWebsite: props.contactWebsite,
    contactRelationship: props.contactRelationship,
    rentAmountFamily: props.rentAmountFamily,
  }), [
    props.address,
    props.streetNumber,
    props.streetName,
    props.streetType,
    props.aptUnit,
    props.city,
    props.state,
    props.zipCode,
    props.country,
    props.outsideUS,
    props.residenceType,
    props.stillHereRent,
    props.moveInDateRent,
    props.leaseEndDate,
    props.landlordName,
    props.landlordEmail,
    props.landlordMobile,
    props.rentAmount,
    props.monthsPaidRent,
    props.stillHereOwn,
    props.moveInDateOwn,
    props.plannedMoveOutDate,
    props.monthlyMortgagePayment,
    props.monthsResided,
    props.stillHereFamily,
    props.moveInDateFamily,
    props.plannedMoveOutDateFamily,
    props.contactName,
    props.contactEmail,
    props.contactMobile,
    props.contactWebsite,
    props.contactRelationship,
    props.rentAmountFamily,
  ])
}

